import { render, staticRenderFns } from "./RiskRelated.vue?vue&type=template&id=54db41fa&scoped=true"
import script from "./RiskRelated.vue?vue&type=script&lang=js"
export * from "./RiskRelated.vue?vue&type=script&lang=js"
import style0 from "./RiskRelated.vue?vue&type=style&index=0&id=54db41fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db41fa",
  null
  
)

export default component.exports